export enum InvoiceTemplatesTableStaticActionType {
  Delete = 'delete',
}
